import { Card, Cell, Icon, Spacer, Text } from '@vinted/web-ui';
import { Plus32 } from '@vinted/monochrome-icons';
import useTranslate from 'hooks/useTranslate';
import useTracking from 'hooks/useTracking';
import { clickEvent } from 'libs/common/event-tracker/events';
import { navigateToPage } from 'libs/utils/window';
import { ClickableElement } from 'constants/tracking/clickable-elements';
import { Screen } from 'constants/tracking/screens';
import { FEATURED_COLLECTION_URL } from 'constants/routes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const AddNewCollectionButton = () => {
  const translate = useTranslate();
  const {
    track
  } = useTracking();

  function handleAddCollectionClick() {
    track(clickEvent({
      screen: Screen.CurrentUserProfile,
      target: ClickableElement.AddCollection
    }));
    navigateToPage(FEATURED_COLLECTION_URL);
  }

  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(Card, {
      children: /*#__PURE__*/_jsx("div", {
        className: "u-flexbox u-fill-height multiple-collections-block__square-box-container",
        children: /*#__PURE__*/_jsx(Cell, {
          type: Cell.Type.Navigating,
          theme: "transparent",
          onClick: handleAddCollectionClick,
          testId: "multiple-collections-add-collection-button",
          children: /*#__PURE__*/_jsx("div", {
            className: "u-flexbox u-justify-content-center",
            children: /*#__PURE__*/_jsx(Icon, {
              color: Icon.Color.Primary,
              name: Plus32,
              display: Icon.Display.InlineBlock
            })
          })
        })
      })
    }), /*#__PURE__*/_jsx(Spacer, {}), /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Text, {
        text: translate('featured_collection.multiple.collections_block.actions.add'),
        type: Text.Type.Title,
        theme: "amplified"
      })
    })]
  });
};

export default AddNewCollectionButton;